export default __webpack_public_path__ + "static/media/react.2fad5f46.png";